export default "__VITE_PUBLIC_ASSET__5c1857e1__"